import { NAME } from './constants';
import { router } from './router';

export const UzaverkaObjednavekNd = {
	name: NAME,
	router,
};
